/**
 * Firebase client setup - used only for the password reset SMS OTP
 * flow (see pages/ResetPasswordFirebase.js). The Firebase JS SDK
 * talks directly to Firebase's own servers to send and verify the
 * OTP; this app's backend never touches the SMS itself, it only
 * verifies the ID token Firebase hands back afterward.
 *
 * All values below come from your Firebase project's web app config
 * (Firebase Console -> Project Settings -> General -> Your apps ->
 * SDK setup and configuration). None of these are secret - they're
 * meant to be public/embedded in client-side code, unlike the
 * backend's service account key.
 */

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export function isFirebaseConfigured() {

    return !!(firebaseConfig.apiKey && firebaseConfig.authDomain && firebaseConfig.projectId);

}

let app = null;

let authInstance = null;

export function getFirebaseAuth() {

    if (!isFirebaseConfigured()) {

        return null;

    }

    if (!app) {

        app = initializeApp(firebaseConfig);

        authInstance = getAuth(app);

    }

    return authInstance;

}
